import styled from 'styled-components';

import { ButtonV2 } from '@getgrover/ui';

const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
`;

const Title = styled.h2`
    ${({ theme }) => theme.typography.Subheadline};
    color: ${({ theme }) => theme.colors.Foreground};
    margin-bottom: 8px;
`;

const SubTitle = styled.p`
    ${({ theme }) => theme.typography.Paragraph};
    margin-bottom: 16px;
`;

const BackButton = styled(ButtonV2)`
    margin-top: 24px;
`;

export { Wrap, Title, SubTitle, BackButton };
